import React from "react";
import { ordinalWord } from "../../utils/ordinal";

interface DrawSummaryCardProps {
  drawNo?: string;
  prizes: Array<{
    description: string;
    winners: number;
    reserves: number;
  }>;
  status?: string;
}

/**
 * Reusable component to display draw summary information
 * Used in both ConfirmationStep and DrawDetailComponent
 */
const DrawSummaryCard: React.FC<DrawSummaryCardProps> = ({
  drawNo,
  prizes,
  status,
}) => {
  return (
    <div
      style={{
        marginBottom: "var(--plexus-space-xl)",
        backgroundColor:
          status === "completed"
            ? "var(--plexus-color-positive-50)"
            : "var(--plexus-color-surface-50)",
        borderRadius: "var(--plexus-border-radius-md)",
        padding: "var(--plexus-space-xl)",
        border:
          status === "completed"
            ? `var(--plexus-border-width-thin) solid var(--plexus-color-positive-200)`
            : `var(--plexus-border-width-thin) solid var(--plexus-color-neutral-600)`,
      }}
    >
      <div
        style={{
          display: "grid",
          gap: "var(--plexus-space-xl)",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        }}
      >
        {/* Draw ID */}
        {drawNo && (
          <div>
            <div
              style={{
                fontWeight: 600,
                color: "var(--plexus-color-positive-400)",
                marginBottom: "var(--plexus-space-sm)",
                fontSize: "0.875rem",
                textTransform: "uppercase",
                letterSpacing: "0.025em",
              }}
            >
              Draw ID
            </div>
            <div
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                color: "var(--plexus-color-neutral-100)",
              }}
            >
              {drawNo}
            </div>
          </div>
        )}

        {/* All Prizes */}
        {prizes.map((prize, index) => {
          // Generate ordinal label (First, Second, Third, ..., 11th, 12th, etc.)
          const prizeLabel = `${ordinalWord(index + 1)} prize`;

          return (
            <div key={index}>
              <div
                style={{
                  fontWeight: 600,
                  color: "var(--plexus-color-positive-400)",
                  marginBottom: "var(--plexus-space-sm)",
                  fontSize: "0.875rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.025em",
                }}
              >
                {prizeLabel}
              </div>
              <div
                style={{
                  fontSize: "1rem",
                  fontWeight: 400,
                  color: "var(--plexus-color-neutral-100)",
                }}
              >
                {prize.description} ({prize.winners} winner
                {prize.winners !== 1 ? "s" : ""})
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DrawSummaryCard;
